import { useSelector } from 'react-redux'
import { selectGroups } from '../../../../../slices/groupSlice'
import GroupCard from './GroupCard/GroupCard'

type Props = {
  target: string
}

const GroupList = (props: Props) => {
  const { target } = props
  const groups = useSelector(selectGroups)
  return (
    <>
      {groups.length ? (
        groups.map((group) => (
          <GroupCard group={group} key={group.id} target={target} />
        ))
      ) : (
        <span>
          関連するグループは見つかりませんでした。新しいグループを作成してください
        </span>
      )}
    </>
  )
}

export default GroupList
